export class ScenarioRoutePaths {
  static challengeAFlow(teamId: string, workspaceId: string) {
    return `/${teamId}/${workspaceId}/prototypes/new`;
  }

  static mainSite(scenarioId: string) {
    return `/${scenarioId}`;
  }

  static challengeAFlowAsAGuest() {
    return '/guest/prototypes/new';
  }

  static configureNewChallenge(teamId: string, workspaceId: string, nodeId: string) {
    return `/${teamId}/${workspaceId}/prototypes/new/${nodeId}`;
  }

  static configureNewChallengeAsAGuest(nodeId: string) {
    return `/guest/prototypes/new/${nodeId}`;
  }

  static challengeDetails(teamId: string, workspaceId: string, scenarioId: string) {
    return `/${teamId}/${workspaceId}/prototypes/${scenarioId}`;
  }

  static challengeDetailsWithSimulationStart(teamId: string, workspaceId: string, scenarioId: string) {
    return `/${teamId}/${workspaceId}/prototypes/${scenarioId}?action=start`;
  }

  static challengeSimulation(teamId: string, workspaceId: string, scenarioId: string, reviewId: string) {
    return `/${teamId}/${workspaceId}/prototypes/${scenarioId}/simulation/${reviewId}`;
  }

  static challengeSimulationAsAGuest(teamId: string, workspaceId: string, scenarioId: string, reviewId: string) {
    return `/guest/${teamId}/${workspaceId}/prototypes/${scenarioId}/simulation/${reviewId}`;
  }

  static setUpHumanTesting(teamId: string, workspaceId: string, scenarioId: string) {
    return `/${teamId}/${workspaceId}/prototypes/${scenarioId}/human-testing`;
  }
}
